<header class="emptyHeaderMain"></header>
<div class="container" *ngIf="user">
  <div class="row">
    <div class="col-lg-12 buttons header">
      <a
        *ngIf="currentUser && currentUser._id === user._id"
        routerLink="/profile"
        class="btn btn-secondary">
        Edit Profile
      </a>
    </div>

    <div class="col-lg-4 no-r-m">
      <div class="profile-holder">
        <img class="profile-pic" src="{{ profilePicUrl }}" alt />
      </div>
    </div>
    <div class="col-lg-8 no-l-m">
      <div class="row">
        <div class="col-lg-12 no-l-m no-r-m">
          <h1>{{ user.first_name }} {{ user.name }}</h1>
          <br />
        </div>

        <div class="col-lg-6 no-l-m no-r-m" *ngIf="user.organization">
          <label class="form-label" for="">Organization</label>
          <div class="val">{{ user.organization }}</div>
        </div>
        <div class="col-lg-6 no-l-m no-r-m" *ngIf="user.department">
          <label class="form-label" for="">Department</label>
          <div class="val">{{ user.department }}</div>
        </div>
        <div class="col-lg-6 no-l-m no-r-m" *ngIf="user.occupation">
          <label class="form-label" for="">Occupation</label>
          <div class="val">{{ user.occupation }}</div>
        </div>

        <ng-container *ngIf="hasContactInfo">
          <div class="col-lg-12 no-l-m no-r-m">
            <h3>Contact Information</h3>
            <br />
          </div>
          <div class="col-lg-6 no-l-m no-r-m" *ngIf="user.email">
            <label class="form-label" for="">Email</label>
            <div class="val">{{ user.email }}</div>
          </div>

          <ng-container *ngIf="hasLocation">
            <div class="col-lg-6 no-l-m no-r-m" *ngIf="user.location.zipcode">
              <label class="form-label" for="">Zip Code</label>
              <div class="val">{{ user.location.zipcode }}</div>
            </div>
            <div class="col-lg-6 no-l-m no-r-m" *ngIf="user.location.city">
              <label class="form-label" for="">City</label>
              <div class="val">{{ user.location.city }}</div>
            </div>
            <div class="col-lg-6 no-l-m no-r-m" *ngIf="user.location.country">
              <label class="form-label" for="">Country</label>
              <div class="val">{{ user.location.country }}</div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="col-lg-12 buttons">
      <button class="btn btn-primary btn-lg" (click)="openDirectMsg()">
        Send Message
      </button>
    </div>
  </div>
</div>

<br />
<br />
<br />
<br />
